import { render, staticRenderFns } from "./FormRekonKurirCopy.vue?vue&type=template&id=bd916a1c&scoped=true"
import script from "./FormRekonKurirCopy.vue?vue&type=script&lang=js"
export * from "./FormRekonKurirCopy.vue?vue&type=script&lang=js"
import style0 from "./FormRekonKurirCopy.vue?vue&type=style&index=0&id=bd916a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd916a1c",
  null
  
)

export default component.exports